export default "__VITE_ASSET__BkY$A6qT__"